import React, { useState, useEffect } from 'react';
import './DialogFornitore.css';

import { getLocale } from '../../locales/getLocale';
import { plainRetrieve, plainStore } from '../../utils/safeStoring';
import { DEFAULT_FORNITORE } from './defaults';

import SlDialog from '@shoelace-style/shoelace/dist/react/dialog';
import SlTab from '@shoelace-style/shoelace/dist/react/tab';
import SlTabGroup from '@shoelace-style/shoelace/dist/react/tab-group';
import SlTabPanel from '@shoelace-style/shoelace/dist/react/tab-panel';
import SlInput from '@shoelace-style/shoelace/dist/react/input';
import SlButton from '@shoelace-style/shoelace/dist/react/button';


function DialogFornitore ({ isOpen, setIsOpen }) {

    const savedFornitore = plainRetrieve('savedFornitore') || '';
    const [activeTab, setActiveTab] = useState(savedFornitore.length > 0 ? savedFornitore : 'persona-fisica');

    // update value of activeTab at every tab change
    useEffect(() => {
        const tabGroup = document.getElementById('navigation-tabs');

        if (tabGroup) {
        const handleTabShow = (event) => {
            setActiveTab(event.detail.name);
        };

        tabGroup.addEventListener('sl-tab-show', handleTabShow);

        // Cleanup event listener on unmount
        return () => {
            tabGroup.removeEventListener('sl-tab-show', handleTabShow);
        };
        }
    }, []);

    const [infoFornitore, setInfoFornitore] = useState(plainRetrieve('infoFornitore') || DEFAULT_FORNITORE);
    
    const setValue = (tab, key, value) => {
        const newInfoFornitore = { ...infoFornitore };
        if (tab.length > 0) {
            newInfoFornitore[tab][key] = value;
        } else {
            newInfoFornitore[key] = value;
        }
        setInfoFornitore(newInfoFornitore);
    }


    const handleSave = () => {
        // codice_fiscale is a shared field -> overwrite according to the active tab
        if (activeTab === 'persona-fisica') {
            infoFornitore.codice_fiscale = infoFornitore.persona_fisica.pf_codice_fiscale;
        } else if (activeTab === 'partita-iva') {
            infoFornitore.codice_fiscale = infoFornitore.partita_iva.piva_codice_fiscale;
        }
        plainStore('infoFornitore', infoFornitore);
        plainStore('savedFornitore', activeTab);
        setIsOpen(false);
    }

    
    return (
        <SlDialog 
            label={getLocale('DialogFornitore.title')}
            open={isOpen} 
            onSlRequestClose={() => setIsOpen(false)}
            className="dialog-info"
        >
        
            <div className="fornitore-dialog-body">

                <SlTabGroup className="navigation-tabs" id="navigation-tabs">
                    <SlTab slot="nav" panel="persona-fisica" active={activeTab === 'persona-fisica'}>
                        <div className="tab-title">
                            {getLocale('DialogFornitore.tabPersonaFisica')}
                        </div>
                    </SlTab>
                    <SlTab slot="nav" panel="partita-iva" active={activeTab === 'partita-iva'}>
                        <div className="tab-title">
                            {getLocale('DialogFornitore.tabPartitaIVA')}
                        </div>
                    </SlTab>

                    <SlTabPanel name="persona-fisica" active={activeTab === 'persona-fisica'}>
                        <div className="tab-content">
                            {/* <SlInput
                                label={getLocale(`DialogFornitore.fields.pf_codice_fiscale.label`)}
                                placeholder={getLocale(`DialogFornitore.fields.pf_codice_fiscale.placeholder`)}
                                value={infoFornitore.persona_fisica.codice_fiscale}
                                onSlInput={(e) => setValue('persona_fisica', 'codice_fiscale', e.target.value)}
                            /> */}
                            {Object.entries(infoFornitore.persona_fisica).map(([key, value]) => (
                                <SlInput
                                    key={key}
                                    type={getLocale(`DialogFornitore.fields.${key}.type`)}
                                    label={getLocale(`DialogFornitore.fields.${key}.label`)}
                                    placeholder={getLocale(`DialogFornitore.fields.${key}.placeholder`)}
                                    value={value}
                                    onSlInput={(e) => setValue('persona_fisica', key, e.target.value)}
                                />
                            ))}
                        </div>
                    </SlTabPanel>

                    <SlTabPanel name="partita-iva" active={activeTab === 'partita-iva'}>
                        <div className="tab-content">
                            {/* <SlInput
                                type="number"
                                label={getLocale(`DialogFornitore.fields.piva_codice_fiscale.label`)}
                                placeholder={getLocale(`DialogFornitore.fields.piva_codice_fiscale.placeholder`)}
                                value={infoFornitore.partita_iva.codice_fiscale}
                                onSlInput={(e) => setValue('partita_iva', 'codice_fiscale', e.target.value)}
                                
                            /> */}
                            {Object.entries(infoFornitore.partita_iva).map(([key, value]) => (
                                <SlInput
                                    key={key}
                                    type={getLocale(`DialogFornitore.fields.${key}.type`)}
                                    label={getLocale(`DialogFornitore.fields.${key}.label`)}
                                    placeholder={getLocale(`DialogFornitore.fields.${key}.placeholder`)}
                                    value={value}
                                    onSlInput={(e) => setValue('partita_iva', key, e.target.value)}
                                />
                            ))}
                        </div>
                    </SlTabPanel>
                
                </SlTabGroup>

            </div>

            <SlButton slot="footer" variant="primary" onClick={() => handleSave()}>
                {getLocale('DialogFornitore.btnSave')}
            </SlButton>
        
        </SlDialog>
    );
};


export default DialogFornitore;
